import { render } from "./Main.vue?vue&type=template&id=e87c092a"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\งาน NOT\\outlier\\TableauEmbed\\unileverEmbed\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__